import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Sparkles } from 'lucide-react';

import { fetchConversas } from '@/api/secretario';
import { queryKeys } from '@/lib/pwa/queryConfig';

import { quando, situacaoDe } from './atendimento/util';

/**
 * Uma linha na pasta do cliente apontando para o atendimento do Secretário que a
 * criou (ou reaproveitou). Só a linha: tudo o que o cliente entregou já está em
 * "Documentos" da própria pasta.
 */
export function AtendimentoDoCliente({ clienteId }: { clienteId: string }) {
  const { data } = useQuery({
    queryKey: queryKeys.secretario.atendimentosDoCliente(clienteId),
    queryFn: () => fetchConversas({ cliente_id: clienteId, limit: 5 }),
    // Sem Secretário configurado a API responde 404: silêncio, não erro.
    retry: false,
  });
  const atendimentos = (data ?? []).filter((c) => c.estado === 'CONCLUSAO');
  if (atendimentos.length === 0) return null;

  return (
    <ul className="space-y-1">
      {atendimentos.map((c) => (
        <li key={c.id}>
          <Link
            to={`/app/secretario-ia/atendimentos/${c.id}`}
            className="inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-md border px-3 py-2 text-sm hover:bg-accent/40"
          >
            <Sparkles className="h-4 w-4 text-primary" aria-hidden="true" />
            <span>
              Atendimento pelo Secretário concluído {quando(c.concluido_em)}
              {c.area_nome ? ` · ${c.area_nome}` : ''}
            </span>
            <span className="text-xs text-muted-foreground">· {situacaoDe(c).rotulo} · abrir</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
